import { useQuery } from "react-query";
import AttendanceApiClient from "api/AttendanceApiClient";

export function useMunicipalitySchoolsAttendance(municipalityId) {
    return useQuery(["municipalitySchoolsAttendance", { municipalityId }], () =>
        AttendanceApiClient.getMunicipalitySchoolsAttendance(municipalityId),
    );
}
